var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfilrationTank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6026,
    cy: 21.6026,
    r: 20.7717,
    stroke: "#64E7A5",
    strokeWidth: 1.66174
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_1874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2765 19.9864C28.1181 19.9864 27.9612 19.9931 27.806 20.0056C26.9326 16.1352 22.1056 10.3037 19.9779 8.4877C19.718 8.25152 19.3212 8.25147 19.0613 8.4877C16.0027 11.1707 10.5407 18.1558 10.8113 22.857C10.744 29.7705 18.7611 33.9871 24.396 30.0686C28.0418 33.4152 34.0832 30.7739 34.0659 25.7758C34.066 22.5836 31.4688 19.9864 28.2765 19.9864ZM19.5196 30.2028C15.4691 30.2028 12.1738 26.9075 12.1738 22.8569C12.1738 17.5546 17.8483 11.5796 19.5203 9.93454C20.4266 10.8238 25.055 15.4545 26.4645 20.2756C22.8846 21.3828 21.304 25.9498 23.4927 29.0363C22.309 29.8015 20.9485 30.2028 19.5196 30.2028ZM28.2765 30.2028C25.8355 30.2028 23.8496 28.2169 23.8496 25.7759C24.0722 19.9111 32.4818 19.9127 32.7034 25.7759C32.7034 28.2169 30.7175 30.2028 28.2765 30.2028Z",
    fill: "#64E7A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0925 22.8571C15.0925 22.4808 14.7875 22.1758 14.4112 22.1758C14.035 22.1758 13.7299 22.4808 13.7299 22.8571C13.7299 24.4011 14.3319 25.8546 15.425 26.9498C16.0866 27.5653 17.0033 26.6493 16.3894 25.9873C15.5531 25.1493 15.0925 24.0376 15.0925 22.8571Z",
    fill: "#64E7A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4011 24.4392C29.727 24.251 29.8386 23.8343 29.6505 23.5085L29.499 23.2462C29.2476 22.811 28.7794 22.5406 28.2769 22.5408C27.7744 22.5409 27.3062 22.8112 27.055 23.2463L26.9035 23.5088C26.7154 23.8347 26.8272 24.2514 27.1531 24.4394C27.479 24.6275 27.8957 24.5157 28.0837 24.1898L28.235 23.9274C28.2522 23.8977 28.3017 23.8977 28.3188 23.9275L28.4705 24.1899C28.6586 24.5157 29.0753 24.6273 29.4011 24.4392Z",
    fill: "#64E7A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9995 26.7369L26.6966 26.7371C26.6623 26.7371 26.6375 26.6942 26.6548 26.6645L26.8062 26.4019C27.2286 25.6032 26.106 24.9559 25.6261 25.7207L25.4747 25.983C25.2234 26.4183 25.2235 26.959 25.4748 27.3941C25.7261 27.8292 26.1943 28.0995 26.6966 28.0995H26.9998C27.3761 28.0994 27.681 27.7943 27.6809 27.418C27.6809 27.0418 27.3758 26.7368 26.9995 26.7369Z",
    fill: "#64E7A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9272 25.7208C30.4467 24.9555 29.3248 25.604 29.7471 26.402L29.8985 26.6645C29.9157 26.6942 29.891 26.737 29.8567 26.7371L29.5538 26.7369C29.1775 26.7369 28.8724 27.0418 28.8723 27.4181C28.8723 27.7943 29.1772 28.0994 29.5534 28.0995H29.8566C30.359 28.0995 30.8272 27.8292 31.0785 27.3941C31.3298 26.959 31.3298 26.4183 31.0786 25.9831L30.9272 25.7208Z",
    fill: "#64E7A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_1874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2643,
    height: 23.2643,
    fill: "white",
    transform: "translate(10.8014 8.30859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfilrationTank);
export default __webpack_public_path__ + "static/media/InfilrationTank.a90239c60cdece4ba454f7b70d369c24.svg";
export { ForwardRef as ReactComponent };